import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.header = {
      display: 'flex',
      width: ['fit-content', '100%'],
      flexDirection: 'column',
    };

    this.heading = {
      variant: 'text.h1',
      flex: 1,
      mx: [10, 8],
    };
  })()
);
